const ClientsMarquee = () => {
  // Liste des clients avec leurs vrais logos
  const clients = [
    { name: 'TotalEnergies', logo: '/images/clients/totalenergies.png' },
    { name: 'Eurovia', logo: '/images/clients/eurovia.png' },
    { name: 'Roland Garros', logo: '/images/clients/rolandgarros.svg' },
    { name: 'TokTok Agency', logo: '/images/clients/toktok.png' },
    { name: 'RocketVid', logo: '/images/clients/rocketvid.webp' },
    { name: 'lePermisLibre', logo: '/images/clients/lepermislibre.webp' },
    { name: 'Call me Boss', logo: '/images/clients/callmeboss.svg' },
    { name: 'Webyn.ai', logo: '/images/clients/webyn.webp' },
    { name: 'GreenKub', logo: '/images/clients/greenkub.webp' },
  ];

  // Dupliquer la liste pour un défilement vraiment infini
  const allClients = [...clients, ...clients, ...clients, ...clients];

  return (
    <div className="w-full">
      {/* Titre */}
      <p className="text-center mb-8 text-xl md:text-2xl">
        <span className="text-[#2A41E5] font-semibold">+ de 30 clients B2B</span>
        <span className="text-gray-500"> nous font confiance.</span>
      </p>

      {/* Bande défilante avec masque */}
      <div 
        className="relative overflow-hidden"
        style={{
          maskImage: 'linear-gradient(to right, transparent 0%, black 10%, black 90%, transparent 100%)',
          WebkitMaskImage: 'linear-gradient(to right, transparent 0%, black 10%, black 90%, transparent 100%)'
        }}
      >
        {/* Conteneur animation - défilement infini */}
        <div className="flex animate-marquee-infinite">
          {allClients.map((client, idx) => (
            <div 
              key={idx} 
              className="shrink-0 mx-10 grayscale opacity-50 hover:grayscale-0 hover:opacity-100 transition-all duration-300"
              title={client.name}
            >
              <img 
                src={client.logo} 
                alt={client.name}
                className="h-8 max-w-[120px] object-contain"
              />
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default ClientsMarquee;
